var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { AuthFrame } from "peggirkit";
var SerpotrackAuthFrame = function (_a) {
    var title = _a.title, logo = _a.logo, onSignedInRedirectTo = _a.onSignedInRedirectTo, children = _a.children;
    return (_jsx(AuthFrame, __assign({ icon: logo, title: title, appName: "Serpotrack", subTitle: _jsxs("p", __assign({ className: "mt-2 text-center text-sm text-gray-600" }, { children: [_jsx(FormattedMessage, { id: "or" }), ' ', _jsx("a", __assign({ href: "https://serpotrack.com", className: "font-medium text-blue-600 hover:text-blue-500" }, { children: _jsx(FormattedMessage, { id: "visitOurHomepage" }) }))] })), onSignedInRedirectTo: onSignedInRedirectTo }, { children: children })));
};
export default SerpotrackAuthFrame;
